import { useTranslation } from "react-i18next";
import { Mail, Trash2 } from "lucide-react";
import { NeuButton } from "../../components/neu/Neu";
import { StaffMeta } from "./StaffMeta";

export const StaffRow = ({ member, onResend, onRemove, isSelf }) => {
  const { t } = useTranslation();
  const primary = Boolean(member.owner_seed_version);
  return (
    <div className="neu-in flex flex-wrap items-center justify-between gap-3 rounded-2xl p-4" data-testid={`staff-row-${member.email}`}>
      <div>
        <p className="text-sm font-bold">{member.name || member.email}</p>
        <p className="text-xs text-muted-foreground">{member.email}</p>
        <StaffMeta member={member} />
      </div>
      <div className="flex items-center gap-2">
        <span className="rounded-xl bg-primary/10 px-3 py-1 text-xs font-semibold text-primary">
          {t(`staff.roles.${member.role}`)}
        </span>
        <span className="text-xs font-semibold text-muted-foreground">{t(`staff.status.${member.status || "active"}`)}</span>
        {!primary && member.status === "pending" ? (
          <NeuButton className="px-3 py-2" data-testid={`staff-resend-${member.email}`} onClick={() => onResend(member.id)}>
            <Mail className="h-4 w-4" />
          </NeuButton>
        ) : null}
        {!primary && !isSelf ? (
          <NeuButton variant="danger" className="px-3 py-2" data-testid={`staff-remove-${member.email}`} onClick={() => onRemove(member.id)}>
            <Trash2 className="h-4 w-4" />
          </NeuButton>
        ) : null}
      </div>
    </div>
  );
};
